import {
  Flex,
  Heading,
  Text,
  Icon,
  Image,
  useColorModeValue
} from "@chakra-ui/react";
import { IconType } from 'react-icons';

export interface ContentInfoCardProps {
  icon?: IconType;
  imageUrl?: string;
  header: string;
  content: string | JSX.Element;
}

export default function ContentInfoCard({
  icon,
  imageUrl,
  header,
  content
}: ContentInfoCardProps) {
  const cardBg = useColorModeValue('gray.50', 'gray.800');
  const cardBorder = useColorModeValue('gray.200', 'gray.700');

  function renderIcon() {
    if (icon) {
      return <Icon as={icon} w={8} h={8} />;
    }

    if (imageUrl) {
      return <Image src={imageUrl} w={16} h={16} borderRadius="md" objectFit="cover" />
    }

    return null;
  }

  return (
    <Flex
      direction='column'
      gap={4}
      bg={cardBg}
      border="1px solid"
      borderColor={cardBorder}
      borderRadius="xl"
      p={{ base: 6, md: 8 }}
      boxShadow="sm"
      height="100%"
      width="320px"
      minWidth="320px"
      maxWidth="320px"
    >
      <Flex alignItems={'center'} gap={3} justifyContent={'center'}>
        {renderIcon()}
        <Heading fontSize={{ base: 'xl', md: '2xl' }} textAlign={'left'}> {header} </Heading>
      </Flex>
      <Text fontSize={{ base: 'xs', md: 'sm' }} textAlign={'center'} flex={1}> {content} </Text>
    </Flex>
  );
}
